import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareDataClassificationsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareDataClassificationsRoute.tsx';
import { ProjectSettingsDetailsSkeleton } from '@jira/platform__skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import DataClassifications, {
	LazyDataClassificationsSettings,
} from './ui/project-settings/data-classifications/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareDataClassificationsRouteEntry: Route = createEntry(
	projectSettingsSoftwareDataClassificationsRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: DataClassifications,
		skeleton: ProjectSettingsDetailsSkeleton,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyDataClassificationsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);

/**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */
